module.exports = __webpack_public_path__ + "media/images/shark/Leona_1-b87d2e0a193efe3f241529f385372b34.jpg";